import { ERROR, LOADING, READY, useVisualState } from '../../../hooks/useVisualState'
import { useHistory } from 'react-router-dom'
import React, { useCallback, useEffect } from 'react'
import t from '../../../helpers/i18n'
import CompetitionCard from '../../../components/Cards/CompetitionCard/CompetitionCard'
import { oldGet } from '../../../helpers/requestOld'
import LoadingPanel from '../../../components/Loading/LoadingPanel'

const CompetitionsView = () => {
  const history = useHistory()
  const [[competitionsState, competitions], setCompetitions] = useVisualState()

  const handleOpenCompetition = useCallback((competition_id) => {
    history.push('/soccer/competition/' + competition_id)
  }, [history])

  useEffect(() => {
    setCompetitions(LOADING)
    oldGet('/cm/categories')
      .then((response) => {
        setCompetitions(READY, response)
      })
      .catch((error) => {
        setCompetitions(ERROR, error)
      })
  }, [setCompetitions])

  return (
    <div className="main-content">
      <div className="-page-header">
        <div className="-left label-display-medium-semibold">{t('titles.Competitions')}</div>
      </div>
      <div className="-content">
        {competitionsState === READY && competitions.map((competition) => (
          <CompetitionCard
            competition_id={competition.category_id}
            name={competition.name}
            address={competition.address}
            logo={competition.logo}
            teamsCount={competition.teams_count}
            emailsCount={competition.emails_count}
            onClick={handleOpenCompetition}
          />
        ))}
        {competitionsState === LOADING && <LoadingPanel/>}
      </div>
    </div>
  )
}

export default CompetitionsView
